import { memo } from 'react';

import type { RichTextActionField, BaseTypeProps } from 'schemaBuilder/types';

import { TypeWrapper } from '../../ui';

import RichTextBody from './body';

export interface Props extends BaseTypeProps {
  field: RichTextActionField;
}

export const RichText = ({
  isDragging,
  field,
  dragElement,
  removeElement,
  typeSelectElement,
  fieldKeyElement,
  path,
  theme,
  readonly
}: Props) => {
  return (
    <TypeWrapper
      readonly={readonly}
      schemaField={field.schemaField}
      required={field.required}
      isDragging={isDragging}
      dragElement={dragElement}
      typeSelectElement={typeSelectElement}
      removeElement={removeElement}
      fieldKeyElement={fieldKeyElement}
      path={path}
      theme={theme}
    >
      <RichTextBody
        readonly={readonly}
        schemaField={field.schemaField}
        path={path}
      />
    </TypeWrapper>
  );
};

export default memo(RichText);
